<template>
    <el-dialog class="editor-dialog" :title="'PR'+ String(model.seq).padStart(5, '0')+'订单详情'" append-to-body :visible.sync="visible" :show-close="false" width="85%" top="2vh">
      <el-tabs type="card" v-model="activeTabName">
        <el-tab-pane label="基本信息" name="1">
          <el-descriptions title="垂直带边框列表" direction="vertical" :column="1" border>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                订单描述
              </template>
              <span class="content">{{ model.description}}</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                关联客户
              </template>
              <span class="content">{{ calcCustomer(model.customerId) }}</span>
            </el-descriptions-item> 
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                客户联系人
              </template>
              <span class="content"><el-tag v-for="item in model.customerContact" :key="item._id" type="primary" plain style="margin: 2px;">{{ item.name }}</el-tag></span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                订单项数 | 物料总数
              </template>
              <el-tag type="primary" plain style="margin-right: 2px;">{{ model.list.length }}</el-tag>
              <el-tag type="success" plain style="margin-right: 2px;">{{ totalQty }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                订单金额
              </template>
              <span class="content">{{ totalOrders }}</span>
            </el-descriptions-item> 
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                订单状态
              </template>
              <el-tag :type="model.status?'success':'warning'" effect="plain">{{ model.status?'已存档':'进行中' }}</el-tag>
            </el-descriptions-item> 
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                交货条件
              </template>
              <span class="content">{{ model.deliveryTerm }}</span>
            </el-descriptions-item> 
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                备注说明
              </template>
              <span class="content">{{ model.remark }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="订单明细" name="2">
          <el-table :data="model.list" header-align="center" size="small" highlight-current-row :cell-style="{padding:'5px',fontSize:'13px',borderColor:'#ddd'}" ref="multipleTable" height="500" :row-style="{height:'45px'}" border stripe :header-cell-style="headerStyle">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="name" label="产品名称" align="center" min-width="100"></el-table-column>
            <el-table-column prop="description" label="规格描述" align="left" min-width="200"></el-table-column>
            <el-table-column prop="brand" label="品牌" align="center" min-width="100"></el-table-column>
            <el-table-column prop="unit" label="单位" align="center" min-width="80"></el-table-column>  
            <el-table-column prop="quantity" label="数量" align="center" min-width="80"></el-table-column>   
            <el-table-column label="订单单价" align="center" min-width="100">
              <template slot-scope="scope">
                <span>{{ calcOrderPrice(scope.row.orderUnitPrice,scope.row.quantity,scope.row.currency) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="订单合价" align="center" min-width="100">
              <template slot-scope="scope">
                <span>{{ calcOrderPrice(scope.row.orderUnitPrice,scope.row.quantity,scope.row.currency,true) }}</span>
              </template>
            </el-table-column> 
            <el-table-column prop="remark" label="备注" align="center" min-width="90"></el-table-column> 
          </el-table>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>
  </template>
  <script>
  import http from '@/http'
  import Store from '@/store'
  export default {
  data() {
    return {
      visible: false,
      orderId:'',
      activeTabName:'1',
      model:{list:[]},
      customerOptions:[],
      user_id:Store.state.user_id
    };
  },
  computed:{
    totalQty(){
      const totalQty=this.model.list.reduce((pre,cur)=>{
          return pre+(cur.quantity?Number(cur.quantity):0)
        },0)
      return totalQty
    },
    totalOrders(){
      const totalOrders=this.model.list.reduce((pre,cur)=>{
          return pre+(cur.quantity&&cur.orderUnitPrice?cur.quantity*cur.orderUnitPrice:0)
        },0)
      if(this.model.currency=='CNY'){
        return totalOrders.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
      }else{
        return totalOrders.toLocaleString('en-US', { style: 'currency', currency:'USD' })
      }
    }, 
  },
  methods:{
    async fetchOrder() {
      const res = await http.get(`sales/order/id/${this.orderId}`);
      this.model = res.data
    }, 
    calcSalesUnitPrice(costUnitPrice,costCurrency,salesPriceFactor,currency,USDRate){
      if(currency=='CNY'){
        if(costCurrency=='CNY'){
          return (costUnitPrice*salesPriceFactor).toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })          
        }else{
          return (costUnitPrice*salesPriceFactor*USDRate).toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })  
        }
      }else{
        if(costCurrency=='CNY'){
          return (costUnitPrice*salesPriceFactor/USDRate).toLocaleString('en-US', { style: 'currency', currency:'USD' })          
        }else{
          return (costUnitPrice*salesPriceFactor).toLocaleString('en-US', { style: 'currency', currency:'USD' })  
        }
      }
    },
    calcCustomer(customerId){
      if(customerId){
        const customer=this.customerOptions.find(v=>v._id==customerId)
        return customer?customer.name:''
      }
    },
    async getCustomerByUserId(){
      const res = await http.get(`/sales/customer`,{
        params: { user_id:this.user_id}
      })
      this.customerOptions=res.data
    },
    calcOrderPrice(unitPrice,quantity,currency,isSubtotal){
      if(unitPrice&&quantity&&isSubtotal){
        if(currency=='CNY'){
          return (unitPrice*quantity).toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
        }else{
          return (unitPrice*quantity).toLocaleString('en-US', { style: 'currency', currency:'USD' })
        }
      }else if(unitPrice&&quantity){
        if(currency=='CNY'){
          return unitPrice.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
        }else{
          return unitPrice.toLocaleString('en-US', { style: 'currency', currency:'USD' })
        }
      }
    },
  },
  created(){
    this.fetchOrder()
    this.getCustomerByUserId()
  }
  };
  </script>
  <style scoped>
  .editor-dialog>>>.el-dialog__header {
    text-align: center !important;
    padding:5px;
  }
  .editor-dialog>>>.el-dialog__body {
    padding:5px;
  }
  .editor-dialog>>>.el-dialog__title {
    font-weight: 700 !important;
  }
  .editor-dialog>>>.el-textarea__inner{
    font-family: Arial, Helvetica, sans-serif;
  }
  .editor-dialog>>>.el-descriptions__header{
    display: none;
  }
  .editor-dialog>>>.el-tabs__header{
    margin:3px;
  }
  .image{
    height: 40px;
    width: 40px;
    margin: auto;
    cursor: pointer;
  }
  .content{
    display:inline-block;
    height:15px!important;
    padding: 0;
  }
  </style>
  